export enum EFeatureLimitItemsType {
  DEALS = "deals",
}
